<template>
  <div class="">
 <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button @click="back">返回列表</el-button>
        <!-- <el-button type="info" plain size="small" @click="back"
          >返回列表</el-button
        > -->
      </div>
  </ZnBreadcrumb>
  <div class="main-content"
       v-title
       data-title="商品详情_试剂采购库存管理系统">

    <div class="goods-info">
      <div class="order-info">
        <span class="code">订单编号：{{orderNo}}</span>
        <span>总金额：<i>¥{{payAmount}} 元</i></span>
      </div>
      <div v-for="(item,index) in myOrderList"
           :key="index">
        <el-table :data="item"
                  :header-cell-style="{background:'#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight:700,height:'54px'
                }"
                  border
                  style="width: 100%">
          <el-table-column prop="supplierName"
                           label="供应商">
          </el-table-column>
          <el-table-column prop="goodsNo"
                           label="商品编码">
          </el-table-column>
          <el-table-column prop="goodsName"
                           label="商品名称">
          </el-table-column>
          <el-table-column prop="casNo"
                           label="CAS号">
          </el-table-column>
          <el-table-column label="结构式">
            <template slot-scope="scope">
              <img :src="scope.row.structionImg"
                   alt="">
            </template>
          </el-table-column>
          <!-- <el-table-column prop="weight"
                           label="重量（单位）">
          </el-table-column> -->
           <el-table-column 
                          label="重量（单位）">
            <template slot-scope="scope">
              <span>{{scope.row.weight}}{{unit(scope.row.weightUnit)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num"
                           label="购买量">
          </el-table-column>
     <!--     <el-table-column prop="salesPrice"
                           label="金额">
          </el-table-column> -->
		  
		  <el-table-column prop="salesPrice" label="金额" >
		  			   <template slot-scope="scope">
		  					{{ scope.row.salesPrice }} 元
		  			   </template>
		  </el-table-column>  
		  
		  
        </el-table>
        <div class="last">
          <p>{{item[0].specNames}}</p>
        </div>
      </div>

    </div>
  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      myOrderList: [],
      payAmount: '',
      orderNo: '',
    }
  },
  created() {
    this.getGoodsDetail()
    this.orderNo = this.$route.query.No
    this.payAmount = this.$route.query.price
  },
  methods: {
    // 单位
    unit(reagentWeightUnit){ //单位适配
      return reagentWeightUnit == 1 ? "mL" : reagentWeightUnit == 2?"g": 
                reagentWeightUnit == 3?"mg": reagentWeightUnit == 4?"L":reagentWeightUnit == 5?"kg":reagentWeightUnit == 6?"KU":reagentWeightUnit == 7?"U":""
    },
    //订单详情
    getGoodsDetail() {
      let ordersId = this.$route.params.id
      this.$apiFetch
        .get(`/lockerOrdersItems/list?ordersId=${ordersId}`)
        .then((res) => {
          res.data.map((item) => {
            item = [item]
            this.myOrderList.push(item)
          })
        })
    },
    back() {
      this.$router.back();
    }
  },
}
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}
.order-info {
  border-bottom: 1px solid #eef2f8;
  background-color: #ffffff;
  padding-bottom: 20px;
  span {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    line-height: 24px;
    i {
      color: #fa8c16;
    }
  }
  span.code {
    padding-right: 60px;
  }
}
/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;
}
.goods-info {
  padding: 20px;
  background-color: #ffffff;
  img {
    display: block;
    width: 80px;
  }
}
.last {
  border: 1px solid #e8e8e8;
  border-top: unset;
  height: 53px;
  border-radius: 0 0 4px 4px;
  p {
    color: rgba(0, 0, 0, 0.65);
    line-height: 54px;
    font-size: 12px;
    padding-left: 16px;
  }
}
</style>

